'use strict';
const _ = require('underscore');
module.exports = function extendWithIcons(base, urlBase, iconSize) {
	const extended = {};
	_.each(base, function (val, key) {
		const item = _.omit(val, 'style'),
			iconName = key || 'not-started';
		item.icon = {
			height: iconSize,
			width: iconSize,
			position: 'left',
			url: urlBase + iconName + '.png'
		};
		extended[key] = item;
	});
	return extended;
};
